module.exports = __webpack_public_path__ + "static/media/GAS2-NEW.ef7ac630.apng";